import React from 'react';
import useLabelsTool from '../hooks/useLabelsTool';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';
import GenericLabelsToolbarPopupContent from './GenericLabelsToolbarPopupContent';

const ElementLabelsToolbarPopupContent: React.FC<LabelsToolbarPopupProps> = (props) => {
    const controller = useLabelsTool({ currentUserId: props.currentUserId });

    return <GenericLabelsToolbarPopupContent controller={controller} />;
};

export default ElementLabelsToolbarPopupContent;
